module.exports = () => ({ ok: true });
